import { Button, Input, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
import {
  createTermsAndConditionsVersion,
  getLatestTermsAndConditions,
} from "../../utils/termsService";
import { Notify } from "../../utils/constants";

const { TextArea } = Input;

const TermsAndConditionsSection = () => {
  const [termsText, setTermsText] = useState<string>("");
  const [latestCreatedAt, setLatestCreatedAt] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const loadLatestTerms = useCallback(async () => {
    setIsLoading(true);
    try {
      const latestTerms = await getLatestTermsAndConditions();
      setTermsText(latestTerms?.text || "");
      setLatestCreatedAt(latestTerms?.createdAt || null);
    } catch (error) {
      console.error("Failed to fetch terms and conditions:", error);
      Notify("error", "Could not load Terms and Conditions.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadLatestTerms();
  }, [loadLatestTerms]);

  const handleSave = async () => {
    const normalizedText = termsText.trim();
    if (!normalizedText) {
      Notify("error", "Terms and Conditions text cannot be empty.");
      return;
    }

    setIsSaving(true);
    try {
      const createdTerms = await createTermsAndConditionsVersion(normalizedText);
      setTermsText(createdTerms.text);
      setLatestCreatedAt(createdTerms.createdAt);
      Notify("success", "Terms and Conditions updated successfully.");
    } catch (error) {
      console.error("Failed to save terms and conditions:", error);
      Notify("error", "Could not save Terms and Conditions.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="section-container" style={{ marginTop: 16 }}>
      <Typography.Title level={4}>Terms and Conditions</Typography.Title>
      {latestCreatedAt && (
        <Typography.Paragraph type="secondary">
          Latest version created at: {new Date(latestCreatedAt).toLocaleString()}
        </Typography.Paragraph>
      )}
      <TextArea
        rows={10}
        value={termsText}
        onChange={(event) => setTermsText(event.target.value)}
        placeholder="Enter Terms and Conditions text"
        disabled={isLoading || isSaving}
      />
      <Button
        type="primary"
        style={{ marginTop: 12 }}
        onClick={handleSave}
        loading={isSaving}
        disabled={isLoading}
      >
        Save Terms and Conditions
      </Button>
    </div>
  );
};

export default TermsAndConditionsSection;
